export enum PaymentType {
    CreditCard = 1,
    ACH = 2,
    ApplePay = 3,
    GooglePay = 4,
}

export const paymentTypeLabels = ['', 'Credit Card', 'ACH', 'Apple Pay', 'Google Pay'];
